import React from 'react';

import CheckCircle from '@components/CheckCircle/index';

import useUniqueId from '@hooks/useUniqueId';

import {
  BodyText,
  InputStyle,
  RadioButtonStyle,
  SelectBox,
} from './RadioButton.style';

export default function RadioButton({
  label = '',
  selected = '',
  onClick,
  value = '',
  group = '',
  spacing = '0',
}: {
  group?: string;
  label?: string;
  onClick?: (value: boolean | number | string) => void;
  selected?: boolean | number | string;
  spacing?: string;
  value?: boolean | number | string;
}) {
  const uniqueID = useUniqueId('radio-button');

  function handleClick() {
    if (onClick) {
      onClick(value);
    }
  }

  return (
    <InputStyle>
      <label htmlFor={uniqueID} style={{ margin: 0 }}>
        <input
          checked={selected === value}
          id={uniqueID}
          name={group}
          onChange={handleClick}
          type="radio"
        />
        <SelectBox spacing={spacing}>
          <RadioButtonStyle>
            <CheckCircle selected={selected === value} size={25} />
          </RadioButtonStyle>
          <BodyText>
            <p>{label}</p>
          </BodyText>
        </SelectBox>
      </label>
    </InputStyle>
  );
}
